import * as MaterialIcons from '@material-ui/icons';

export default {
  Icons: [
    {Name: "Accessibility", Icon: MaterialIcons.Accessibility},
    {Name: "AccountBalance", Icon: MaterialIcons.AccountBalance},
    {Name: "AcUnit", Icon: MaterialIcons.AcUnit},
    {Name: "Add", Icon: MaterialIcons.Add},
    {Name: "Album", Icon: MaterialIcons.Album},
    {Name: "AllInclusive", Icon: MaterialIcons.AllInclusive},
    {Name: "Assignment", Icon: MaterialIcons.Assignment},
    {Name: "AttachMoney", Icon: MaterialIcons.AttachMoney},
    {Name: "BeachAccess", Icon: MaterialIcons.BeachAccess},
    {Name: "Block", Icon: MaterialIcons.Block},
    {Name: "BubbleChart", Icon: MaterialIcons.BubbleChart},
    {Name: "BugReport", Icon: MaterialIcons.BugReport},
    {Name: "Build", Icon: MaterialIcons.Build},
    {Name: "Business", Icon: MaterialIcons.Business},
    {Name: "Brightness1", Icon: MaterialIcons.Brightness1},
    {Name: "Brightness3", Icon: MaterialIcons.Brightness3},
    {Name: "Brightness5", Icon: MaterialIcons.Brightness5},
    {Name: "Brush", Icon: MaterialIcons.Brush},
    {Name: "Call", Icon: MaterialIcons.Call},
    {Name: "Cake", Icon: MaterialIcons.Cake},
    {Name: "Casino", Icon: MaterialIcons.Casino},
    {Name: "CameraAlt", Icon: MaterialIcons.CameraAlt},
    {Name: "ChatBubbleOutline", Icon: MaterialIcons.ChatBubbleOutline},
    {Name: "ChangeHistory", Icon: MaterialIcons.ChangeHistory},
    {Name: "CheckCircle", Icon: MaterialIcons.CheckCircle},
    {Name: "ChildFriendly", Icon: MaterialIcons.ChildFriendly},
    {Name: "ChildCare", Icon: MaterialIcons.ChildCare},
    {Name: "Computer", Icon: MaterialIcons.Computer},
    {Name: "ContentCut", Icon: MaterialIcons.ContentCut},
    {Name: "ContentPaste", Icon: MaterialIcons.ContentPaste},
    {Name: "Create", Icon: MaterialIcons.Create},
    {Name: "CreditCard", Icon: MaterialIcons.CreditCard},
    {Name: "Cloud", Icon: MaterialIcons.Cloud},
    {Name: "DateRange", Icon: MaterialIcons.DateRange},
    {Name: "Delete", Icon: MaterialIcons.Delete},
    {Name: "Description", Icon: MaterialIcons.Description},
    {Name: "DirectionsBike", Icon: MaterialIcons.DirectionsBike},
    {Name: "DirectionsBoat", Icon: MaterialIcons.DirectionsBoat},
    {Name: "DirectionsBus", Icon: MaterialIcons.DirectionsBus},
    {Name: "DirectionsCar", Icon: MaterialIcons.DirectionsCar},
    {Name: "DirectionsRun", Icon: MaterialIcons.DirectionsRun},
    {Name: "DirectionsWalk", Icon: MaterialIcons.DirectionsWalk},
    {Name: "Email", Icon: MaterialIcons.Email},
    {Name: "Equalizer", Icon: MaterialIcons.Equalizer},
    {Name: "Explore", Icon: MaterialIcons.Explore},
    {Name: "Extension", Icon: MaterialIcons.Extension},
    {Name: "Face", Icon: MaterialIcons.Face},
    {Name: "FastForward", Icon: MaterialIcons.FastForward},
    {Name: "FastRewind", Icon: MaterialIcons.FastRewind},
    {Name: "Favorite", Icon: MaterialIcons.Favorite},
    {Name: "FiberNew", Icon: MaterialIcons.FiberNew},
    {Name: "Fingerprint", Icon: MaterialIcons.Fingerprint},
    {Name: "FilterVintage", Icon: MaterialIcons.FilterVintage},
    {Name: "FitnessCenter", Icon: MaterialIcons.FitnessCenter},
    {Name: "Flight", Icon: MaterialIcons.Flight},
    {Name: "FormatPaint", Icon: MaterialIcons.FormatPaint},
    {Name: "FreeBreakfast", Icon: MaterialIcons.FreeBreakfast},
    {Name: "Games", Icon: MaterialIcons.Games},
    {Name: "Gavel", Icon: MaterialIcons.Gavel},
    {Name: "Gif", Icon: MaterialIcons.Gif},
    {Name: "Grade", Icon: MaterialIcons.Grade},
    {Name: "Headset", Icon: MaterialIcons.Headset},
    {Name: "Healing", Icon: MaterialIcons.Healing},
    {Name: "HelpOutline", Icon: MaterialIcons.HelpOutline},
    {Name: "HighlightOff", Icon: MaterialIcons.HighlightOff},
    {Name: "Home", Icon: MaterialIcons.Home},
    {Name: "Hotel", Icon: MaterialIcons.Hotel},
    {Name: "HourglassEmpty", Icon: MaterialIcons.HourglassEmpty},
    {Name: "Http", Icon: MaterialIcons.Http},
    {Name: "Info", Icon: MaterialIcons.Info},
    {Name: "InsertEmoticon", Icon: MaterialIcons.InsertEmoticon},
    {Name: "MoodBad", Icon: MaterialIcons.MoodBad},
    {Name: "InsertPhoto", Icon: MaterialIcons.InsertPhoto},
    {Name: "Language", Icon: MaterialIcons.Language},
    {Name: "LightbulbOutline", Icon: MaterialIcons.LightbulbOutline},
    {Name: "LocalCafe", Icon: MaterialIcons.LocalCafe},
    {Name: "LocalFlorist", Icon: MaterialIcons.LocalFlorist},
    {Name: "Lock", Icon: MaterialIcons.Lock},
    {Name: "Kitchen", Icon: MaterialIcons.Kitchen},
    {Name: "MarkunreadMailbox", Icon: MaterialIcons.MarkunreadMailbox},
    {Name: "Mic", Icon: MaterialIcons.Mic},
    {Name: "Motorcycle", Icon: MaterialIcons.Motorcycle},
    {Name: "Movie", Icon: MaterialIcons.Movie},
    {Name: "MusicNote", Icon: MaterialIcons.MusicNote},
    {Name: "NotInterested", Icon: MaterialIcons.NotInterested},
    {Name: "PanTool", Icon: MaterialIcons.PanTool},
    {Name: "Pause", Icon: MaterialIcons.Pause},
    {Name: "PieChart", Icon: MaterialIcons.PieChart},
    {Name: "PlayArrow", Icon: MaterialIcons.PlayArrow},
    {Name: "Pets", Icon: MaterialIcons.Pets},
    {Name: "Pool", Icon: MaterialIcons.Pool},
    {Name: "Power", Icon: MaterialIcons.Power},
    {Name: "PhonelinkErase", Icon: MaterialIcons.PhonelinkErase},
    {Name: "PowerSettingsNew", Icon: MaterialIcons.PowerSettingsNew},
    {Name: "PregnantWoman", Icon: MaterialIcons.PregnantWoman},
    {Name: "Print", Icon: MaterialIcons.Print},
    {Name: "QuestionAnswer", Icon: MaterialIcons.QuestionAnswer},
    {Name: "RecordVoiceOver", Icon: MaterialIcons.RecordVoiceOver},
    {Name: "Redeem", Icon: MaterialIcons.Redeem},
    {Name: "Restaurant", Icon: MaterialIcons.Restaurant},
    {Name: "Room", Icon: MaterialIcons.Room},
    {Name: "RssFeed", Icon: MaterialIcons.RssFeed},
    {Name: "Rowing", Icon: MaterialIcons.Rowing},
    {Name: "Save", Icon: MaterialIcons.Save},
    {Name: "Schedule", Icon: MaterialIcons.Schedule},
    {Name: "School", Icon: MaterialIcons.School},
    {Name: "Settings", Icon: MaterialIcons.Settings},
    {Name: "ShoppingCart", Icon: MaterialIcons.ShoppingCart},
    {Name: "SmokingRooms", Icon: MaterialIcons.SmokingRooms},
    {Name: "SmokeFree", Icon: MaterialIcons.SmokeFree},
    {Name: "Terrain", Icon: MaterialIcons.Terrain},
    {Name: "ThumbDown", Icon: MaterialIcons.ThumbDown},
    {Name: "ThumbUp", Icon: MaterialIcons.ThumbUp},
    {Name: "Timeline", Icon: MaterialIcons.Timeline},
    {Name: "TrackChanges", Icon: MaterialIcons.TrackChanges},
    {Name: "Visibility", Icon: MaterialIcons.Visibility},
    {Name: "VisibilityOff", Icon: MaterialIcons.VisibilityOff},
    {Name: "VpnKey", Icon: MaterialIcons.VpnKey},
    {Name: "Weekend", Icon: MaterialIcons.Weekend},
    {Name: "Whatshot", Icon: MaterialIcons.Whatshot},
    {Name: "Work", Icon: MaterialIcons.Work}
  ]
};



// WEBPACK FOOTER //
// ./src/configs/IconConfig.js